import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  { heading: 'Tenant access' },
  {
    page: PageMeta.TenantUsers.List,
    title: 'Users',
    icon: { icon: 'tabler-users' },
    to: PageMeta.TenantUsers.List.Name,
  },
  {
    page: PageMeta.TenantRoles.List,
    title: 'Roles',
    icon: { icon: 'tabler-shield' },
    to: PageMeta.TenantRoles.List.Name,
  },
  {
    page: PageMeta.TenantRolePermissions.List,
    title: 'Role permissions',
    icon: { icon: 'tabler-key' },
    to: PageMeta.TenantRolePermissions.List.Name,
  },
  {
    page: PageMeta.TenantPermissionDefinitions.List,
    title: 'Permission definitions',
    icon: { icon: 'tabler-list' },
    to: PageMeta.TenantPermissionDefinitions.List.Name,
  },
]
